import { gql } from '@apollo/client';

export const GET_FEATURE_FLAGS = gql`
  query GetFeatureFlags($input: FeatureFlagsInput) {
    getFeatureFlags(input: $input)
  }
`;
